'use strict';

var app = new Vue({
    el: '#article-list',
    data: {
        articles: [],
        tags: [],
        filterTags: [],
        loading: true,
        busy: false,
        currentArticle: null,
        showArticle: false,
        noMoreArticles: false,
        showingAllTags: true,
        orderByColumns: [],
        galleryImages: []
    },
    beforeMount: function beforeMount() {
        window.addEventListener('scroll', this.handleScroll, { passive: true });
    },
    mounted: function mounted() {
        this.$nextTick(function () {
            this.loadMoreContent(true);
        });
    },

    computed: {

        prevArticleExists: function prevArticleExists() {
            var currentIndex = this._findCurrentIndex();
            var prev = this.articles[currentIndex - 1];
            if (prev) {
                return true;
            }
        },
        nextArticleExists: function nextArticleExists() {
            var currentIndex = this._findCurrentIndex();
            var fullList = this.articles.length;
            var next = this.articles[currentIndex + 1];
            var remainingArticles = fullList - (currentIndex + 1);
            if (remainingArticles < 5) {
                this.loadMoreContent(false);
            }
            if (next !== null) {
                return true;
            }
        }
    },
    methods: {
        _getSignUpUrl: function _getSignUpUrl(fullPath) {
            var url = fullPath + "#membertrip";
            return url;
        },
        _goToSignupUrl: function _goToSignupUrl(fullPath) {
            fullPath = fullPath + "#membertrip";
            window.location.href = fullPath;
            location.reload();
        },
        _getFullTagUrl: function _getFullTagUrl(name) {
            return "/search?selectedTag=" + name;
        },
        _showArticle: function _showArticle(article, e) {
            var _this = this;

            e.preventDefault();

            axios.post('/TrackPage?pageVersionId=' + article.pageVersionId).then(function (res) {
                _this.loading = false;
            }).catch(function (error) {
                console.log(error);
            });

            history.pushState("", article.fullPath, article.fullPath);

            document.getElementById('someFB').dataset.url = window.location.origin + article.fullPath;
            this.currentArticle = article;
            this.showArticle = true;

            this._initiateFlexSlider();

            var tl = new TimelineMax();
            var articleAnimate = document.getElementById('article-detail');
            var articleBg = document.getElementById('articleBg');

            tl.fromTo(articleAnimate, 0.5, {
                opacity: 0,
                y: 300
            }, {
                opacity: 1,
                y: 0
            });

            tl.fromTo(articleBg, 0.4, {
                opacity: 0
            }, {
                opacity: 1
            }, "-=0.4");
        },
        _showAllTags: function _showAllTags() {
            Array.from(this.tags).forEach(function (tag, i) {
                tag.show = true;
            });
            this.showingAllTags = true;
        },
        _initiateFlexSlider: function _initiateFlexSlider() {
            $('#trip-flex').flexslider("destroy");

            this.galleryImages = [];
            this.galleryImages = this.currentArticle.galleryImages;
            console.log(this.galleryImages);
            setTimeout(function () {
                console.log("initiate flex");

                $('#trip-flex').flexslider({
                    animation: "slide",
                    slideshow: false,
                    animationLoop: false,
                    controlNav: false
                });
            }, 100);

            return true;
        },
        _findCurrentIndex: function _findCurrentIndex() {
            var index;
            var currentArticle = this.currentArticle;
            Array.from(this.articles).forEach(function (article, i) {
                if (article === currentArticle) {
                    index = i;
                }
            });
            return index;
        },
        _showNextArticle: function _showNextArticle() {
            var currentIndex = this._findCurrentIndex();
            var nextArticle = this.articles[currentIndex + 1];
            if (nextArticle) {
                this.currentArticle = nextArticle;
                this._initiateFlexSlider();
            }
        },
        _showPreviousArticle: function _showPreviousArticle() {
            var currentIndex = this._findCurrentIndex();
            var prevArticle = this.articles[currentIndex - 1];
            if (prevArticle) {
                this.currentArticle = prevArticle;
                this._initiateFlexSlider();
            }
        },
        _close: function _close(e) {
            var tl = new TimelineMax({ onComplete: this._doneClosing });
            e.preventDefault();

            var articleAnimate = document.getElementById('article-detail');
            var articleBg = document.getElementById('articleBg');

            tl.fromTo(articleAnimate, 0.3, {
                opacity: 1,
                y: 0
            }, {
                opacity: 0,
                y: 300
            });

            tl.fromTo(articleBg, 0.4, {
                opacity: 1
            }, {
                opacity: 0
            }, "-=0.4");
        },
        _doneClosing: function _doneClosing() {
            this.showArticle = false;
            window.history.pushState('medlemsturer', 'medlemsturer', '/medlemsturer');
        },
        handleScroll: function handleScroll() {
            var footerHeight = document.getElementsByTagName('footer')[0].clientHeight;
            if (!this.noMoreArticles) {
                if (window.innerHeight + window.scrollY >= document.body.offsetHeight - footerHeight * 1.5 && !this.loading) {
                    this.loading = true;
                    this.loadMoreContent(false);
                }
            }
        },
        findGetParameter: function findGetParameter(parameterName) {
            var result = null,
                tmp = [];
            location.search.substr(1).split("&").forEach(function (item) {
                tmp = item.split("=");
                if (tmp[0] === parameterName) result = decodeURIComponent(tmp[1]);
            });
            return result;
        },
        loadMoreContent: function loadMoreContent(fetchNew) {
            var _this2 = this;

            if (!this.noMoreArticles) {
                if (fetchNew) {
                    this.pageIndex = 0;
                    this.articles = [];
                } else {
                    this.pageIndex++;
                }

                var fetchNewFromJs = this.findGetParameter('fetchNew');

                var data = {
                    selectedTags: this.getSelectedTags(),
                    currentPageCount: this.articles.length,
                    fetchNew: fetchNewFromJs,
                    orderBy: this.getSelectedOrderByColumn()
                };

                axios.post('/medlemsturer/getmembertrips/', data).then(function (res) {
                    console.log(res);
                    _this2.orderByColumns = res.data.orderByColumns;
                    _this2.tags = res.data.tags;
                    var oldarticles = _this2.articles;
                    var newarticles = res.data.articles;
                    var newArray = oldarticles.concat(newarticles);
                    _this2.articles = newArray;
                    if (res.data.articles.length === 0) {
                        _this2.noMoreArticles = true;
                    }
                    _this2.loading = false;
                }).catch(function (error) {
                    if (error.response.status === 401) {
                        // reload the page to get another AT
                        window.location.reload();
                    }
                });
            }
        },
        selectTag: function selectTag(tag) {
            this.loading = true;
            tag.selected = !tag.selected;
            this.noMoreArticles = false;
            this.loadMoreContent(true);
        },
        selectOrderByColumn: function selectOrderByColumn(col) {
            this.loading = true;
            this.orderByColumns.forEach(function (item) {
                if (item.id !== col.id) {
                    item.selected = false;
                }
            });
            col.selected = true;
            this.noMoreArticles = false;
            this.loadMoreContent(true);
        },
        getSelectedTags: function getSelectedTags() {
            var allSelectedTags = [];
            if (this.tags !== null && this.tags.length > 0) for (var i = 0; i < this.tags.length; i++) {
                if (this.tags[i].selected) {
                    allSelectedTags.push(this.tags[i].name);
                }
            }
            return allSelectedTags;
        },
        getSelectedOrderByColumn: function getSelectedOrderByColumn() {
            var selectedCol = 1;
            this.orderByColumns.forEach(function (col) {
                if (col.selected) {
                    selectedCol = col.id;
                }
            });
            return selectedCol;
        }
    }
});